export default __webpack_public_path__ + "static/media/manejoPesquero.f418873a.jpg";